/**
 * Schnellerfassung — Artikelliste aus Excel/CSV einlesen oder einfuegen.
 *
 * Ein Modul fuer drei Einstiegspunkte: Warenkorbseite, Warenkorb-Schubfach und
 * Favoritenliste. Aufruf immer ueber window.BulkImport.open({target, listId}).
 * Drittes Ziel (16.10.2026, Lageretiketten #59): open({target: 'callback', onDone, doneLabel})
 * — prueft wie immer, bucht aber nichts und gibt die Zeilen an onDone zurueck.
 *
 * ⚠️⚠️ DER DIALOG WIRD GENAU EINMAL ERZEUGT. Auf der Warenkorbseite liegen Seite UND
 * Schubfach gleichzeitig im DOM; ein per Snippet eingebettetes <dialog> waere doppelt
 * vorhanden — dieselbe Fehlerklasse wie beim doppelten Warenkorb-DOM im Schubfach, wo
 * jede DOM-Iteration doppelt zaehlt. Deshalb baut dieses Modul das Markup traege selbst
 * und haengt es an <body>.
 *
 * ⚠️⚠️ MENGEN SIND ZWEIDEUTIG. 40 % des Katalogs (440 von 1097 Artikeln) werden in
 * Verkaufseinheiten verkauft — 297 als Gebinde in Stueck, 143 als Meterware. „144" kann
 * 144 Meter oder 144 Ringe à 12 m bedeuten, und der Warenkorb zaehlt AUSSCHLIESSLICH
 * Verkaufseinheiten. Eine stille Fehldeutung ist ein Faktor-12-Fehler in Franken, der
 * erst bei der Lieferung auffaellt. Darum: Vorgabe ist VE, jede betroffene Zeile zeigt
 * die Gesamtmenge im Klartext, und es gibt einen Umschalter je Zeile und fuer alle.
 *
 * ⚠️ window.customStrings ist BEREITS HTML-escaped → ausschliesslich textContent,
 * niemals innerHTML, und nie ein zweites Mal escapen.
 */
(function () {
  'use strict';

  // Mehrfach eingebunden (Warenkorbseite + Schubfach + Favoriten) ist der Normalfall.
  if (window.BulkImport) return;

  var CFG      = window.b2bConfig || {};
  var API      = (CFG.apiBase || '').replace(/\/+$/, '');
  var MAX_ROWS = 500;
  var MAX_BYTES = 2 * 1024 * 1024;
  var CHUNK    = 50;          // Positionen je /cart/add.js-Aufruf
  var DEBOUNCE = 400;

  // ── Texte ──────────────────────────────────────────────────────────────────

  var FALLBACK = {
    title: 'Schnellerfassung', tabPaste: 'Einfügen', tabFile: 'Datei',
    pasteHint: 'Erkannt werden Artikelnummer und Menge. Weitere Spalten werden ignoriert.',
    dropHint: 'Datei hierher ziehen oder auswählen (XLSX, XLS, CSV)',
    chooseFile: 'Datei auswählen', check: 'Prüfen', close: 'Schliessen', cancel: 'Abbrechen',
    back: 'Zurück', colSku: 'Artikelnummer', colName: 'Bezeichnung', colQty: 'Menge',
    colTotal: 'Gesamtmenge', colStatus: 'Status', swapColumns: 'Spalten tauschen',
    headerSkipped: 'Kopfzeile erkannt und übersprungen', headerKeep: 'Doch verwenden',
    unknownSku: 'Artikelnummer nicht gefunden', invalidQty: 'Menge prüfen',
    notAvailable: 'Zurzeit nicht verfügbar', merged: 'Zeilen zusammengefasst',
    removeRow: 'Zeile entfernen', removeUnknown: 'Alle nicht gefundenen entfernen',
    errorsFirst: 'Fehler zuerst', chooseList: 'Liste wählen', newList: 'Neue Liste …',
    qtyRounded: 'Menge auf ganze Einheiten gerundet', nothingFound: 'Keine Artikelnummern erkannt.',
    retryRest: 'Rest erneut versuchen', sheet: 'Tabellenblatt', allInBase: 'Alle Mengen umstellen auf',
    checking: 'Wird geprüft …', loading: 'Einen Moment …', failed: 'Das hat nicht geklappt.',
    // Aufgabe #107 (15.10.2026): Erkennung ueber Code/Bezeichnung, Auswahl, Vorschlaege.
    recognizedAs: 'Ihre Nr. {input} · erkannt als {sku}',
    matchEquivalent: 'Gleichwertiger Artikel – bitte Masse prüfen',
    matchAlternative: 'Alternative – weicht ab, bitte prüfen',
    ambiguous: 'Mehrere Artikel passen – bitte wählen:',
    suggestions: 'Nicht gefunden. Meinten Sie:'
  };

  /**
   * ⚠️ Nur fuer die Texte aus Aufgabe #107. Sie stehen absichtlich NICHT in den
   * Theme-Locales: deren Einbindung liegt in layout/theme.liquid, und die Live-Fassung
   * davon traegt Aenderungen (Cookie-Banner #36), die in der Projektkopie fehlen —
   * ein Push von theme.liquid haette sie still geloescht.
   */
  var FALLBACK_FR = {
    recognizedAs: 'Votre réf. {input} · reconnue comme {sku}',
    matchEquivalent: 'Article équivalent – veuillez vérifier les dimensions',
    matchAlternative: 'Alternative – diffère, veuillez vérifier',
    ambiguous: 'Plusieurs articles correspondent – veuillez choisir :',
    suggestions: 'Introuvable. Vouliez-vous dire :'
  };

  function T(key) {
    var s = window.customStrings || {};
    var v = s['bi' + key.charAt(0).toUpperCase() + key.slice(1)];
    if (typeof v === 'string' && v !== '') return v;
    if (FALLBACK_FR[key] && (document.documentElement.lang || '').slice(0, 2) === 'fr') return FALLBACK_FR[key];
    return FALLBACK[key] || key;
  }

  /** Platzhalter {n} füllen. Rein textuell — nichts hiervon geht je durch innerHTML. */
  function fmt(tpl, vals) {
    return String(tpl).replace(/\{(\w+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(vals, k) ? String(vals[k]) : m;
    });
  }

  // Block S51-SKUIDX-FR (17.09.2026): app_sku_index/der Resolver liefern seit diesem
  // Block `title_fr` (null, wenn Shopify keine FR-Uebersetzung hat) — ohne diese Wahl
  // zeigte die Schnellerfassung auf der FR-Storefront durchweg deutsche Artikelnamen.
  // Nur die ANZEIGE waehlt hier; r.title selbst bleibt unveraendert (u. a. commitList()
  // schickt weiterhin den deutschen Titel an die Favoritenliste — eigenes Thema).
  function displayTitle(r) {
    var fr = (document.documentElement.lang || '').slice(0, 2) === 'fr';

    return (fr && r.title_fr) ? r.title_fr : r.title;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;   // IMMER textContent — nie innerHTML
    return n;
  }

  // ── Zahlen und Artikelnummern ──────────────────────────────────────────────

  /**
   * Menge aus einer Zelle lesen.
   *
   * ⚠️ BEWUSSTE ENTSCHEIDUNG: ein einzelnes Komma ODER ein einzelner Punkt ist IMMER das
   * Dezimalzeichen. „1,000" wird damit zu 1, nicht zu 1000. Aus der Zeichenkette allein
   * ist das nicht aufloesbar — aber die Vorschau zeigt die gelesene Zahl, ein Fehlgriff
   * ist also sichtbar und korrigierbar. Eine stille Vertausendfachung waere es nicht.
   * Tausendertrenner sind hier ' ’ und Leerzeichen (Schweizer Schreibweise).
   */
  function num(raw) {
    if (raw == null) return NaN;
    var s = String(raw).replace(/[  \s'’‘`´]/g, '').replace(/^[+-]/, '');
    if (s === '') return NaN;
    var d = s.lastIndexOf('.'), c = s.lastIndexOf(',');
    if (d >= 0 && c >= 0) {
      var dec = Math.max(d, c);
      s = s.slice(0, dec).replace(/[.,]/g, '') + '.' + s.slice(dec + 1);
    } else if (c >= 0) {
      s = s.replace(',', '.');
    }
    var n = parseFloat(s);
    return isFinite(n) ? n : NaN;
  }

  /**
   * Artikelnummer saeubern.
   * ⚠️ `/` und `.` MUESSEN ueberleben — Abacus-Nummern sehen aus wie G90SWAP1B24/2.
   * Gleiche Zeichenklasse wie serverseitig in SkuResolver::sanitizeSku().
   */
  function cleanSku(raw) {
    return String(raw == null ? '' : raw)
      .replace(/^﻿/, '')
      .replace(/[​-‍⁠]/g, '')
      .replace(/[  ]/g, ' ')
      .trim()
      .replace(/^'+/, '')
      .replace(/[^A-Za-z0-9\-_/.]/g, '')
      .slice(0, 64);
  }

  function round(n, dec) {
    return (window.SU && SU.roundDec) ? SU.roundDec(n, dec)
      : Math.round(n * Math.pow(10, dec)) / Math.pow(10, dec);
  }

  // ── Einfuegetext zerlegen ──────────────────────────────────────────────────

  /**
   * Trennzeichen raten: hoechster Median, geringste Streuung; bei Gleichstand gewinnt
   * der Tabulator — ein Excel-Einfuegen ist immer tabgetrennt.
   */
  function guessDelim(lines) {
    var best = null, bestScore = null;
    ['\t', ';', ',', '|'].forEach(function (d) {
      var counts = lines.map(function (l) { return splitLine(l, d).length - 1; }).sort(function (a, b) { return a - b; });
      var median = counts[Math.floor(counts.length / 2)] || 0;
      if (median < 1) return;
      var spread = counts[counts.length - 1] - counts[0];
      var score = median * 1000 - spread;
      if (bestScore === null || score > bestScore) { bestScore = score; best = d; }
    });
    return best;
  }

  /** Kleiner RFC-4180-Automat: "a;b";1 darf nicht an dem Semikolon in Anfuehrungszeichen brechen. */
  function splitLine(line, delim) {
    var out = [], cur = '', q = false;
    for (var i = 0; i < line.length; i++) {
      var ch = line[i];
      if (q) {
        if (ch === '"') { if (line[i + 1] === '"') { cur += '"'; i++; } else { q = false; } }
        else cur += ch;
      } else if (ch === '"') { q = true; }
      else if (ch === delim) { out.push(cur); cur = ''; }
      else cur += ch;
    }
    out.push(cur);
    return out;
  }

  function parseText(text) {
    var lines = String(text).replace(/\r\n?/g, '\n').split('\n')
      .map(function (l) { return l.replace(/\s+$/, ''); })
      .filter(function (l) { return l.trim() !== ''; });
    if (!lines.length) return [];

    var delim = guessDelim(lines.slice(0, 20));
    return lines.slice(0, MAX_ROWS).map(function (l, i) {
      var cells;
      if (delim) {
        cells = splitLine(l, delim);
      } else {
        // Einspaltenmodus: „K01KAK100GR100 12" am letzten Leerraum trennen.
        var m = l.match(/^(.*\S)\s+(\S+)$/);
        cells = m ? [m[1], m[2]] : [l];
      }
      return { i: i, raw: cells.slice(0, 8).map(function (c) { return String(c).trim(); }) };
    });
  }

  // ── Spaltenzuordnung ───────────────────────────────────────────────────────

  var HEADER_WORDS = /^(artikel|artikel-?nr\.?|art\.?-?nr\.?|artikelnummer|sku|nummer|nr\.?|no\.?|référence|reference|ref\.?|article|bezeichnung|menge|anzahl|stk\.?|stück|stueck|qty|quantity|quantité|qté|pos\.?|position|einheit)$/i;

  function looksLikeSku(s) {
    return /^[A-Za-z0-9][A-Za-z0-9\-_/.]{2,63}$/.test(s) && /[A-Za-z]/.test(s);
  }

  /**
   * Nicht das Trennzeichen geht in der Praxis schief, sondern die Spaltenreihenfolge:
   * „Menge ⇥ Artikelnummer" kommt genauso oft vor wie umgekehrt. Deshalb wird die
   * Entscheidung getroffen UND sichtbar gemacht — mit einem Knopf zum Tauschen.
   */
  function detectMapping(rows) {
    if (!rows.length) return { sku: 0, qty: 1, header: false };

    // Kopfzeile? Entweder ein bekanntes Wort, oder Zeile 1 ohne Zahl und Zeile 2 mit.
    var first = rows[0].raw;
    var header = first.some(function (c) { return HEADER_WORDS.test(String(c).trim()); });
    if (!header && rows.length > 1) {
      var noNum1 = !first.some(function (c) { return isFinite(num(c)); });
      var num2   = rows[1].raw.some(function (c) { return isFinite(num(c)); });
      header = noNum1 && num2;
    }

    var body = rows.slice(header ? 1 : 0, (header ? 1 : 0) + 30);
    var cols = Math.max.apply(null, rows.map(function (r) { return r.raw.length; }));
    var skuScore = [], qtyScore = [];
    for (var c = 0; c < cols; c++) {
      var vals = body.map(function (r) { return String(r.raw[c] == null ? '' : r.raw[c]).trim(); })
                     .filter(function (v) { return v !== ''; });
      var n = vals.length || 1;
      skuScore[c] = vals.filter(function (v) { return looksLikeSku(cleanSku(v)); }).length / n;
      qtyScore[c] = vals.filter(function (v) { var x = num(v); return isFinite(x) && x > 0; }).length / n;
    }

    var sku = 0, bestS = -1;
    for (var i = 0; i < cols; i++) if (skuScore[i] > bestS) { bestS = skuScore[i]; sku = i; }
    if (bestS < 0.6) sku = 0;

    var qty = -1, bestQ = -1;
    for (var j = 0; j < cols; j++) {
      if (j === sku) continue;
      // Die Spalte direkt rechts der Artikelnummer bekommt einen kleinen Bonus.
      var sc = qtyScore[j] + (j === sku + 1 ? 0.15 : 0);
      if (sc > bestQ) { bestQ = sc; qty = j; }
    }
    if (qty < 0 || bestQ <= 0) qty = -1;   // keine Mengenspalte → Menge 1

    return { sku: sku, qty: qty, header: header };
  }

  function colLabel(i) { return i < 0 ? '–' : String.fromCharCode(65 + i); }

  // ── Netz ───────────────────────────────────────────────────────────────────

  function apiHeaders(json) {
    var h = { 'X-Api-Key': CFG.apiKey || '' };
    if (json) h['Content-Type'] = 'application/json';
    return h;
  }

  function fail(r) {
    return r.json().catch(function () { return {}; }).then(function (j) {
      throw Object.assign(new Error(j.error || T('failed')), { kind: j.kind, status: r.status });
    });
  }

  function apiResolve(rows) {
    return fetch(API + '/api/b2b/import/resolve', {
      method: 'POST', headers: apiHeaders(true), body: JSON.stringify({ rows: rows })
    }).then(function (r) { return r.ok ? r.json() : fail(r); });
  }

  function apiParse(file, sheet) {
    var fd = new FormData();
    fd.append('file', file);
    if (sheet) fd.append('sheet', sheet);
    return fetch(API + '/api/b2b/import/parse', { method: 'POST', headers: apiHeaders(false), body: fd })
      .then(function (r) { return r.ok ? r.json() : fail(r); });
  }

  function apiFavImport(payload) {
    var s = null;
    try { s = JSON.parse(localStorage.getItem('b2b_session') || 'null'); } catch (e) { s = null; }
    if (!s || !s.token) return Promise.reject(new Error('anonymous'));
    var h = apiHeaders(true);
    h.Authorization = 'Bearer ' + s.token;
    return fetch(API + '/api/b2b/favorites/import', { method: 'POST', headers: h, body: JSON.stringify(payload) })
      .then(function (r) { return r.ok ? r.json() : fail(r); });
  }

  // ── Zustand ────────────────────────────────────────────────────────────────

  var st = null;
  function freshState(opts) {
    return {
      // 'cart' (Vorgabe) | 'list' (Favoritenliste) | 'callback' (Lageretiketten, #59):
      // Bei 'callback' wird NICHTS gebucht — die erkannten Zeilen gehen an opts.onDone.
      target: opts.target === 'list' ? 'list' : (opts.target === 'callback' && typeof opts.onDone === 'function' ? 'callback' : 'cart'),
      onDone: typeof opts.onDone === 'function' ? opts.onDone : null,
      doneLabel: typeof opts.doneLabel === 'string' ? opts.doneLabel : '',
      listId: opts.listId || null,
      raw: [],            // rohe Zeilen aus Datei/Einfuegefeld
      map: null,          // {sku, qty, header}
      rows: [],           // aufgeloeste Zeilen
      sheets: [], sheet: null, truncated: false,
      errorsFirst: true,
      busy: false,
      trigger: null
    };
  }

  // ── Zeilen aus Rohdaten bauen und aufloesen ────────────────────────────────

  /** Rohzeilen + Zuordnung → {sku, qty} fuer den Server. */
  function toLookupRows() {
    var body = st.raw.slice(st.map.header ? 1 : 0);
    return body.map(function (r, n) {
      var sku = cleanSku(r.raw[st.map.sku]);
      var q   = st.map.qty < 0 ? 1 : num(r.raw[st.map.qty]);
      return { i: n, sku: sku, qty: isFinite(q) ? q : 0 };
    }).filter(function (r) { return r.sku !== '' || r.qty > 0; });
  }

  /**
   * Doppelte Artikelnummern zusammenfassen: Mengen summieren, erste Zeile behalten.
   *
   * ⚠️ NIE ein Fehler. Das ist dieselbe Entscheidung wie im Warenkorb, wo /cart/add.js
   * auf eine bestehende Zeile addiert, und in der Favoritenliste, wo importItems() die
   * Menge erhoeht. Wer hier stattdessen warnte, wuerde einen voellig normalen Fall
   * (dieselbe Schraube in zwei Baugruppen) zum Problem erklaeren.
   */
  function mergeDuplicates(rows) {
    var out = [], byKey = {};
    rows.forEach(function (r) {
      var key = r.status === 'unknown_sku' ? null : String(r.sku).toLowerCase();
      if (key && byKey[key]) {
        var t = byKey[key];
        t.qty = round((t.qty || 0) + (r.qty || 0), 3);
        t.mergedCount = (t.mergedCount || 1) + 1;
        t.mergedParts = (t.mergedParts || [t.qty]).concat([r.qty]);
        if (t.status === 'invalid_qty' && t.qty > 0) t.status = 'ok';
        return;
      }
      if (key) byKey[key] = r;
      out.push(r);
    });
    return out;
  }

  function resolveNow() {
    var lookup = toLookupRows();
    if (!lookup.length) return Promise.reject(new Error(T('nothingFound')));
    if (lookup.length > MAX_ROWS) lookup = lookup.slice(0, MAX_ROWS);

    return apiResolve(lookup).then(function (res) {
      st.rows = mergeDuplicates(res.rows || []).map(function (r) {
        // unitMode: 'pack' = die Zahl meint Verkaufseinheiten (Vorgabe),
        //           'base' = sie meint Basiseinheiten (Meter, Stueck im Gebinde).
        r.unitMode = 'pack';
        return r;
      });
      st.stats = res.stats || {};
      return st.rows;
    });
  }

  // ── Mengen und Einheiten ───────────────────────────────────────────────────

  function hasUnit(r) { return r && r.suq && r.suq > 1 && !r.set; }

  /**
   * Menge in Verkaufseinheiten — das ist die Zahl, die der Warenkorb bekommt.
   *
   * ⚠️ Bei unitMode 'base' rechnet die Zeile von Basiseinheiten auf VE um und rundet
   * AUF: wer 100 m braucht und die Rolle hat 12 m, braucht 9 Rollen, nicht 8. Abrunden
   * hiesse, dem Kunden zu wenig zu liefern.
   */
  function packQty(r) {
    var q = Number(r.qty) || 0;
    if (r.unitMode === 'base' && hasUnit(r)) q = Math.ceil(q / r.suq);
    return q;
  }

  /** Menge in Basiseinheiten — nur zur Anzeige („= 144 m"). */
  function baseQty(r) {
    return hasUnit(r) ? round(packQty(r) * r.suq, 3) : packQty(r);
  }

  /** Was der Warenkorb wirklich annimmt: ganze Zahlen, mindestens 1. */
  function cartQty(r) {
    return Math.max(1, Math.round(packQty(r)));
  }

  function unitLabel(r) {
    return (r && r.sub) ? r.sub : (T('colQty') === 'Menge' ? 'Stück' : 'pcs');
  }

  function rowUsable(r) {
    return r.status === 'ok' && r.id && packQty(r) > 0;
  }

  // ── Dialog ─────────────────────────────────────────────────────────────────

  var dlg = null, elStep1 = null, elStep2 = null, elFoot = null, elLive = null;

  function ensureDialog() {
    if (dlg) return dlg;

    dlg = el('dialog', 'bi');
    dlg.setAttribute('aria-labelledby', 'bi-title');

    var head = el('div', 'bi__head');
    var h = el('h2', 'bi__title', T('title'));
    h.id = 'bi-title';
    head.appendChild(h);
    var x = el('button', 'bi__close');
    x.type = 'button';
    x.setAttribute('aria-label', T('close'));
    x.textContent = '×';
    x.addEventListener('click', close);
    head.appendChild(x);
    dlg.appendChild(head);

    elStep1 = el('div', 'bi__step bi__step--input');
    elStep2 = el('div', 'bi__step bi__step--review');
    elStep2.hidden = true;
    dlg.appendChild(elStep1);
    dlg.appendChild(elStep2);

    elFoot = el('div', 'bi__foot');
    dlg.appendChild(elFoot);

    // Meldungen fuer Hilfsmittel — entprellt, damit das Tippen in der Tabelle
    // nicht bei jedem Zeichen vorgelesen wird.
    elLive = el('div', 'bi__live visually-hidden');
    elLive.setAttribute('role', 'status');
    elLive.setAttribute('aria-live', 'polite');
    dlg.appendChild(elLive);

    // Klick auf den Hintergrund schliesst — gleiche Erkennung wie im Feedback-Modal.
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () {
      if (st && st.trigger && st.trigger.focus) st.trigger.focus();
    });

    document.body.appendChild(dlg);
    return dlg;
  }

  var liveTimer = null;
  function announce(msg) {
    clearTimeout(liveTimer);
    liveTimer = setTimeout(function () { elLive.textContent = msg; }, 500);
  }

  function close() {
    if (dlg && dlg.open) dlg.close();
  }

  // ── Schritt 1: Eingabe ─────────────────────────────────────────────────────

  function renderStep1() {
    elStep1.textContent = '';
    elStep1.hidden = false;
    elStep2.hidden = true;
    elFoot.textContent = '';

    // ── Anleitung ────────────────────────────────────────────────────────────
    // Steht ueber BEIDEN Reitern, weil die Schritte fuer Einfuegen und Datei gleich
    // sind. Bewusst knapp und mit echtem Beispiel: die haeufigste Unsicherheit ist
    // „welche Spalten braucht ihr eigentlich".
    var howto = el('section', 'bi-howto');
    howto.appendChild(el('h3', 'bi-howto__title', T('howtoTitle')));

    var steps = el('ol', 'bi-howto__steps');
    [T('howtoStep1'), T('howtoStep2'), T('howtoStep3')].forEach(function (t) {
      steps.appendChild(el('li', null, t));
    });
    howto.appendChild(steps);

    var ex = el('div', 'bi-howto__example');
    ex.appendChild(el('span', 'bi-howto__exlabel', T('howtoExample')));
    var table = el('table', 'bi-howto__table');
    var thead = el('thead');
    var htr = el('tr');
    [T('colSku'), T('colQty')].forEach(function (h) {
      var th = el('th', null, h); th.scope = 'col'; htr.appendChild(th);
    });
    thead.appendChild(htr);
    table.appendChild(thead);
    var tb = el('tbody');
    [['K01KAK100GR100', '12'], ['G90SWAP1B24/2', '2']].forEach(function (row) {
      var tr = el('tr');
      row.forEach(function (c) { tr.appendChild(el('td', null, c)); });
      tb.appendChild(tr);
    });
    table.appendChild(tb);
    ex.appendChild(table);
    howto.appendChild(ex);

    // ⚠️ Der Hinweis auf Verkaufseinheiten gehoert HIERHER, nicht erst in die Pruefung:
    // 40 % des Katalogs werden in VE verkauft, und wer das erst hinterher liest, hat
    // seine Mengen schon in Metern getippt.
    howto.appendChild(el('p', 'bi-howto__units', T('howtoUnits')));

    elStep1.appendChild(howto);

    // Reiter
    var tabs = el('div', 'bi-tabs');
    tabs.setAttribute('role', 'tablist');
    var panes = el('div', 'bi-panes');

    var defs = [
      { id: 'paste', label: T('tabPaste') },
      { id: 'file',  label: T('tabFile') }
    ];
    var btns = [], panels = [];

    defs.forEach(function (d, i) {
      var b = el('button', 'bi-tab' + (i === 0 ? ' is-active' : ''), d.label);
      b.type = 'button';
      b.id = 'bi-tab-' + d.id;
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      b.setAttribute('aria-controls', 'bi-pane-' + d.id);
      b.tabIndex = i === 0 ? 0 : -1;
      btns.push(b);
      tabs.appendChild(b);

      var p = el('div', 'bi-pane');
      p.id = 'bi-pane-' + d.id;
      p.setAttribute('role', 'tabpanel');
      p.setAttribute('aria-labelledby', b.id);
      p.hidden = i !== 0;
      panels.push(p);
      panes.appendChild(p);
    });

    function activate(idx) {
      btns.forEach(function (b, i) {
        b.classList.toggle('is-active', i === idx);
        b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        b.tabIndex = i === idx ? 0 : -1;
        panels[i].hidden = i !== idx;
      });
      btns[idx].focus();
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { activate(i); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); activate((i + 1) % btns.length); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); activate((i - 1 + btns.length) % btns.length); }
      });
    });

    // — Reiter „Einfuegen"
    var ta = el('textarea', 'bi-paste');
    ta.rows = 8;
    ta.setAttribute('aria-label', T('tabPaste'));
    ta.placeholder = 'K01KAK100GR100\t12\nG90SWAP1B24/2\t2\nP01RP44\t7';
    panels[0].appendChild(ta);
    panels[0].appendChild(el('p', 'bi-hint', T('pasteHint')));

    // Einfuegen loest sofort aus — kein Knopfdruck noetig. Der Knopf bleibt fuer
    // Tastatur- und Hilfsmittelnutzung sowie fuer getippte Eingaben.
    ta.addEventListener('paste', function () {
      setTimeout(function () { if (ta.value.trim()) fromText(ta.value); }, 0);
    });

    // — Reiter „Datei"
    var drop = el('label', 'bi-drop');
    var inp = el('input');
    inp.type = 'file';
    inp.accept = '.xlsx,.xls,.csv,.txt,.tsv';
    inp.className = 'bi-drop__input';
    drop.appendChild(inp);
    drop.appendChild(el('span', 'bi-drop__text', T('dropHint')));
    drop.appendChild(el('span', 'bi-drop__btn', T('chooseFile')));
    panels[1].appendChild(drop);

    inp.addEventListener('change', function () {
      if (inp.files && inp.files[0]) fromFile(inp.files[0]);
    });
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function (e) {
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) fromFile(f);
    });

    elStep1.appendChild(tabs);
    elStep1.appendChild(panes);

    var go = el('button', 'bi-btn bi-btn--primary', T('check'));
    go.type = 'button';
    go.addEventListener('click', function () {
      if (!panels[0].hidden) fromText(ta.value);
      else if (inp.files && inp.files[0]) fromFile(inp.files[0]);
    });
    elFoot.appendChild(go);

    setTimeout(function () { ta.focus(); }, 0);
  }

  function busy(on, msg) {
    st.busy = on;
    dlg.classList.toggle('is-busy', !!on);
    if (on && msg) announce(msg);
  }

  function showError(msg) {
    var box = elStep1.querySelector('.bi-error') || el('p', 'bi-error');
    box.textContent = msg;
    box.setAttribute('role', 'alert');
    if (!box.parentNode) elStep1.insertBefore(box, elStep1.firstChild);
  }

  function fromText(text) {
    var rows = parseText(text);
    if (!rows.length) { showError(T('nothingFound')); return; }
    st.raw = rows; st.sheets = []; st.sheet = null; st.truncated = rows.length >= MAX_ROWS;
    st.map = detectMapping(rows);
    reresolve();
  }

  function fromFile(file) {
    if (file.size > MAX_BYTES) {
      showError(fmt(T('fileTooLarge') || 'Die Datei ist zu gross (höchstens {mb} MB).', { mb: 2 }));
      return;
    }
    busy(true, T('loading'));
    apiParse(file, null).then(function (res) {
      st.raw = res.rows || [];
      st.sheets = res.sheets || [];
      st.sheet = res.sheet || null;
      st.truncated = !!res.truncated;
      st.file = file;
      if (!st.raw.length) { busy(false); showError(T('nothingFound')); return; }
      st.map = detectMapping(st.raw);
      reresolve();
    }).catch(function (e) { busy(false); showError(e.message || T('failed')); });
  }

  /** Blattwechsel liest dieselbe Datei erneut — der Server haelt nichts vor. */
  function switchSheet(name) {
    if (!st.file) return;
    busy(true, T('loading'));
    apiParse(st.file, name).then(function (res) {
      st.raw = res.rows || [];
      st.sheet = res.sheet || name;
      st.truncated = !!res.truncated;
      st.map = detectMapping(st.raw);
      reresolve();
    }).catch(function (e) { busy(false); showError(e.message || T('failed')); });
  }

  function reresolve() {
    busy(true, T('checking'));
    resolveNow().then(function () {
      busy(false);
      renderStep2();
    }).catch(function (e) {
      busy(false);
      // ⚠️ index_unavailable ist KEIN „Ihre Nummern sind falsch" — die Meldung vom
      // Server sagt das bereits klar, sie wird deshalb unveraendert gezeigt.
      showError(e.message || T('failed'));
    });
  }

  // ── Schritt 2: Pruefen ─────────────────────────────────────────────────────

  function counts() {
    var ok = 0, bad = 0, meter = 0;
    st.rows.forEach(function (r) {
      if (rowUsable(r)) ok++; else bad++;
      if (hasUnit(r)) meter++;
    });
    return { ok: ok, bad: bad, meter: meter, total: st.rows.length };
  }

  function renderStep2() {
    var c = counts();
    elStep1.hidden = true;
    elStep2.hidden = false;
    elStep2.textContent = '';

    // — Kopfleiste: Zusammenfassung, Spaltenzuordnung, Blattwahl
    var bar = el('div', 'bi-bar');

    bar.appendChild(el('span', 'bi-bar__sum',
      fmt(T('summary') || '{n} Zeilen · {ok} erkannt · {bad} zu prüfen',
          { n: c.total, ok: c.ok, bad: c.bad })));

    var mapWrap = el('span', 'bi-bar__map');
    mapWrap.appendChild(el('span', 'bi-bar__maptext',
      fmt(T('mapping') || 'Spalte {a} → Artikelnummer · Spalte {b} → Menge',
          { a: colLabel(st.map.sku), b: colLabel(st.map.qty) })));
    var swap = el('button', 'bi-linkbtn', '⇄ ' + T('swapColumns'));
    swap.type = 'button';
    swap.addEventListener('click', function () {
      var s = st.map.sku;
      st.map.sku = st.map.qty < 0 ? s : st.map.qty;
      st.map.qty = s;
      reresolve();
    });
    mapWrap.appendChild(swap);
    bar.appendChild(mapWrap);

    if (st.map.header) {
      var hk = el('button', 'bi-linkbtn', T('headerSkipped') + ' — ' + T('headerKeep'));
      hk.type = 'button';
      hk.addEventListener('click', function () { st.map.header = false; reresolve(); });
      bar.appendChild(hk);
    }

    if (st.sheets && st.sheets.length > 1) {
      var sw = el('label', 'bi-bar__sheet');
      sw.appendChild(el('span', null, T('sheet') + ': '));
      var sel = el('select');
      st.sheets.forEach(function (n) {
        var o = el('option', null, n);
        o.value = n;
        if (n === st.sheet) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () { switchSheet(sel.value); });
      sw.appendChild(sel);
      bar.appendChild(sw);
    }

    elStep2.appendChild(bar);

    /**
     * ⚠️⚠️ Der Sammelumschalter fuer Verkaufseinheiten. Er erscheint nur, wenn die Liste
     * ueberhaupt VE-Artikel enthaelt — dann aber prominent, weil „meine ganze Liste ist
     * in Metern" der haeufigste Fall hinter der teuersten Fehlbestellung ist.
     */
    if (c.meter) {
      var ub = el('div', 'bi-unitbar');
      ub.appendChild(el('span', 'bi-unitbar__label',
        fmt(T('unitBarLabel') || '{n} Artikel werden in Verkaufseinheiten verkauft. Ihre Mengen sind:',
            { n: c.meter })));
      [['pack', T('unitPack') || 'Verkaufseinheiten'], ['base', T('unitBase') || 'Basiseinheiten (m / Stück)']]
        .forEach(function (m) {
          var b = el('button', 'bi-unitbar__btn', m[1]);
          b.type = 'button';
          b.dataset.mode = m[0];
          b.addEventListener('click', function () {
            st.rows.forEach(function (r) { if (hasUnit(r)) r.unitMode = m[0]; });
            renderStep2();
          });
          ub.appendChild(b);
        });
      // Gemischt oder einheitlich? Der aktive Knopf zeigt den vorherrschenden Zustand.
      var modes = st.rows.filter(hasUnit).map(function (r) { return r.unitMode; });
      var allBase = modes.length && modes.every(function (m) { return m === 'base'; });
      Array.prototype.forEach.call(ub.querySelectorAll('.bi-unitbar__btn'), function (b) {
        b.classList.toggle('is-active', (b.dataset.mode === 'base') === !!allBase);
      });
      elStep2.appendChild(ub);
    }

    elStep2.appendChild(buildTable());
    buildFoot();
    announce(fmt(T('summary') || '{n} Zeilen · {ok} erkannt · {bad} zu prüfen',
                 { n: c.total, ok: c.ok, bad: c.bad }));
  }

  function buildTable() {
    var wrap = el('div', 'bi-tablewrap');
    var t = el('table', 'bi-table');

    var thead = el('thead');
    var htr = el('tr');
    ['', T('colSku'), T('colName'), T('colQty'), T('colTotal'), T('colStatus'), ''].forEach(function (h, i) {
      var th = el('th', null, h);
      th.scope = 'col';
      if (i === 0 || i === 6) th.className = 'bi-th--narrow';
      htr.appendChild(th);
    });
    thead.appendChild(htr);
    t.appendChild(thead);

    var tb = el('tbody');
    var rows = st.rows.slice();
    if (st.errorsFirst) {
      rows.sort(function (a, b) { return (rowUsable(a) ? 1 : 0) - (rowUsable(b) ? 1 : 0); });
    }
    rows.forEach(function (r) { tb.appendChild(buildRow(r)); });
    t.appendChild(tb);

    wrap.appendChild(t);
    return wrap;
  }

  function buildRow(r) {
    var tr = el('tr', 'bi-row' + (rowUsable(r) ? '' : ' is-bad'));
    tr.dataset.i = r.i;

    // Bild
    var tdImg = el('td', 'bi-td--img');
    if (r.img) {
      var im = el('img', 'bi-thumb');
      im.src = r.img;
      im.alt = '';
      im.loading = 'lazy';
      tdImg.appendChild(im);
    }
    tr.appendChild(tdImg);

    // Artikelnummer — auf JEDER Zeile bearbeitbar, nicht nur auf fehlerhaften.
    var tdSku = el('td', 'bi-td--sku');
    var iSku = el('input', 'bi-input bi-input--sku');
    iSku.type = 'text';
    iSku.value = r.sku || '';
    iSku.setAttribute('aria-label', T('colSku'));
    if (!rowUsable(r)) iSku.setAttribute('aria-invalid', 'true');
    iSku.addEventListener('change', function () {
      r.sku = cleanSku(iSku.value);
      queueRecheck();
    });
    tdSku.appendChild(iSku);
    tr.appendChild(tdSku);

    // Bezeichnung
    var dispTitle = displayTitle(r);
    var name = dispTitle ? (dispTitle + (r.vt ? ' · ' + r.vt : '')) : '';
    tr.appendChild(el('td', 'bi-td--name', name));

    // Menge + Einheitenumschalter
    var tdQty = el('td', 'bi-td--qty');
    var iQty = el('input', 'bi-input bi-input--qty');
    iQty.type = 'number';
    iQty.min = '0';
    iQty.step = 'any';
    iQty.inputMode = 'decimal';
    iQty.value = r.qty != null ? String(r.qty) : '';
    iQty.setAttribute('aria-label', T('colQty'));
    iQty.addEventListener('change', function () {
      var v = num(iQty.value);
      r.qty = isFinite(v) && v > 0 ? round(v, 3) : 0;
      r.status = r.id ? (r.qty > 0 ? 'ok' : 'invalid_qty') : r.status;
      renderStep2();
    });
    tdQty.appendChild(iQty);

    if (hasUnit(r)) {
      var tog = el('button', 'bi-unit');
      tog.type = 'button';
      tog.textContent = r.unitMode === 'base' ? unitLabel(r) : (T('unitVE') || 'VE');
      tog.title = fmt(T('unitToggleHint') || 'Umschalten: Zahl meint {a} oder {b}',
                      { a: T('unitVE') || 'VE', b: unitLabel(r) });
      tog.addEventListener('click', function () {
        r.unitMode = r.unitMode === 'base' ? 'pack' : 'base';
        renderStep2();
      });
      tdQty.appendChild(tog);
    }
    tr.appendChild(tdQty);

    // Gesamtmenge — die Zeile, die den Faktor-Fehler sichtbar macht.
    var tdTot = el('td', 'bi-td--total');
    if (hasUnit(r) && packQty(r) > 0) {
      tdTot.appendChild(el('span', 'bi-total',
        fmt('{p} × {suq} {u} = {t} {u}',
            { p: packQty(r), suq: round(r.suq, 3), u: unitLabel(r), t: baseQty(r) })));
    } else if (packQty(r) > 0) {
      tdTot.appendChild(el('span', 'bi-total bi-total--plain',
        packQty(r) + ' ' + unitLabel(r)));
    }
    tr.appendChild(tdTot);

    // Status
    var tdSt = el('td', 'bi-td--status');
    var notes = [];
    var kandidaten = r.status === 'unknown_sku' ? (r.auswahl || r.vorschlaege || []) : [];
    if (kandidaten.length) notes.push(['bad', T(r.grund === 'mehrdeutig' ? 'ambiguous' : 'suggestions')]);
    else if (r.status === 'unknown_sku')  notes.push(['bad', T('unknownSku')]);
    else if (r.status === 'invalid_qty' || packQty(r) <= 0) notes.push(['bad', T('invalidQty')]);
    else notes.push(['ok', '✓']);

    // Aufgabe #107: der Kunde soll sehen, dass SEINE Nummer verstanden wurde.
    if (r.erkannt_als && r.eingabe && String(r.eingabe).toLowerCase() !== String(r.erkannt_als).toLowerCase()) {
      notes.push(['info', fmt(T('recognizedAs'), { input: r.eingabe, sku: r.erkannt_als })]);
    }
    // ⚠️ Fast jeder vierte Kreuzreferenz-Treffer ist nicht identisch — ohne Hinweis
    // bestellt der Kunde 8 mm, wo er 10 mm gewohnt ist.
    if (r.art === 'gleichwertig') notes.push(['info', T('matchEquivalent')]);
    else if (r.art === 'alternative') notes.push(['info', T('matchAlternative')]);

    if (r.mergedCount > 1) notes.push(['info', r.mergedCount + ' ' + T('merged')]);
    if (rowUsable(r) && cartQty(r) !== packQty(r)) notes.push(['info', T('qtyRounded')]);
    // ⚠️ Verfuegbarkeit NUR als Hinweis und nur, wenn der Server sie ausdruecklich
    // verneint hat — der Index kennt den Stand von heute Nacht.
    if (rowUsable(r) && r.av === false) notes.push(['info', T('notAvailable')]);

    notes.forEach(function (n) {
      var s = el('span', 'bi-note bi-note--' + n[0], n[1]);
      if (n[0] === 'ok') { s.textContent = '✓'; s.appendChild(el('span', 'visually-hidden', T('ok') || 'erkannt')); }
      tdSt.appendChild(s);
    });

    // Auswahl: mehrdeutig ODER Vorschlaege. ⚠️ Nie vorausgewaehlt — „ASN44" passte einmal
    // auf einen Haltebuegel, gemeint war der Eckwinkel. Erst der Klick des Kunden zaehlt.
    if (kandidaten.length) {
      var wahl = el('div', 'bi-choice');
      kandidaten.forEach(function (k) {
        var t = displayTitle(k);
        var b = el('button', 'bi-choice__btn',
          k.sku + (t ? ' – ' + t : '') + (k.vt ? ' · ' + k.vt : ''));
        b.type = 'button';
        b.addEventListener('click', function () { chooseCandidate(r, k); });
        wahl.appendChild(b);
      });
      tdSt.appendChild(wahl);
    }
    tr.appendChild(tdSt);

    // Entfernen
    var tdDel = el('td', 'bi-td--del');
    var del = el('button', 'bi-iconbtn', '×');
    del.type = 'button';
    del.setAttribute('aria-label', T('removeRow'));
    del.addEventListener('click', function () {
      st.rows = st.rows.filter(function (x) { return x !== r; });
      if (!st.rows.length) { renderStep1(); return; }
      renderStep2();
    });
    tdDel.appendChild(del);
    tr.appendChild(tdDel);

    return tr;
  }

  /** Felder, die nur fuer EINEN Aufloesungsstand gelten — vor jeder Neuaufloesung weg. */
  var ERKENNUNG = ['auswahl', 'vorschlaege', 'grund', 'erkannt_als', 'eingabe', 'quelle', 'art'];

  /**
   * Der Kunde hat aus Auswahl oder Vorschlaegen gewaehlt (Aufgabe #107).
   *
   * Der Kandidat hat dieselbe Form wie eine ok-Zeile (sku, id, pack in Rappen, suq …),
   * die Zeile wird also ohne weiteren Serveraufruf zur ok-Zeile. Menge und
   * Einheitenwahl des Kunden bleiben, wie bei queueRecheck().
   */
  function chooseCandidate(r, k) {
    var eingabe = r.sku, keepQty = r.qty, keepMode = r.unitMode;
    ERKENNUNG.forEach(function (f) { delete r[f]; });
    Object.keys(k).forEach(function (f) { r[f] = k[f]; });
    r.qty = keepQty;
    r.unitMode = keepMode || 'pack';
    r.status = (Number(keepQty) || 0) > 0 ? 'ok' : 'invalid_qty';
    r.eingabe = eingabe;
    r.erkannt_als = k.sku;
    renderStep2();
  }

  /**
   * Inline-Korrekturen entprellt und GEBUENDELT nachschlagen.
   * ⚠️ Eine Anfrage je Zeile waere die eigentliche Last — die Zeilenbremse serverseitig
   * zaehlt zwar Zeilen, aber jede Runde kostet trotzdem eine Netzrunde.
   */
  var recheckTimer = null;
  function queueRecheck() {
    clearTimeout(recheckTimer);
    recheckTimer = setTimeout(function () {
      var lookup = st.rows.map(function (r, n) { return { i: n, sku: r.sku, qty: r.qty || 1 }; });
      busy(true, T('checking'));
      apiResolve(lookup).then(function (res) {
        (res.rows || []).forEach(function (nr) {
          var old = st.rows[nr.i];
          if (!old) return;
          // Menge und Einheitenwahl des Kunden ueberleben den Nachschlag.
          var keepQty = old.qty, keepMode = old.unitMode;
          // ⚠️ Sonst bliebe eine alte Auswahl stehen, obwohl die Zeile jetzt passt.
          ERKENNUNG.forEach(function (f) { delete old[f]; });
          Object.keys(nr).forEach(function (k) { old[k] = nr[k]; });
          old.qty = keepQty;
          old.unitMode = keepMode || 'pack';
          if (old.id && keepQty > 0) old.status = 'ok';
        });
        busy(false);
        renderStep2();
      }).catch(function (e) { busy(false); showError(e.message || T('failed')); });
    }, DEBOUNCE);
  }

  // ── Fusszeile: Ziel und Uebernahme ─────────────────────────────────────────

  function buildFoot() {
    elFoot.textContent = '';
    var c = counts();

    var left = el('div', 'bi__footleft');

    var back = el('button', 'bi-btn bi-btn--ghost', T('back'));
    back.type = 'button';
    back.addEventListener('click', renderStep1);
    left.appendChild(back);

    if (c.bad) {
      var rm = el('button', 'bi-linkbtn', T('removeUnknown'));
      rm.type = 'button';
      rm.addEventListener('click', function () {
        st.rows = st.rows.filter(rowUsable);
        if (!st.rows.length) { renderStep1(); return; }
        renderStep2();
      });
      left.appendChild(rm);
    }
    elFoot.appendChild(left);

    var right = el('div', 'bi__footright');
    var listSel = null, newName = null;

    // Ziel „Favoritenliste": Auswahl bestehender Listen plus „Neue Liste …".
    if (st.target === 'list') {
      var F = window.Favorites;
      var own = (F && F.ownLists) ? F.ownLists() : [];
      listSel = el('select', 'bi-select');
      listSel.setAttribute('aria-label', T('chooseList'));
      own.forEach(function (l) {
        var o = el('option', null, l.name);
        o.value = String(l.id);
        if (st.listId && String(l.id) === String(st.listId)) o.selected = true;
        listSel.appendChild(o);
      });
      var oNew = el('option', null, T('newList'));
      oNew.value = '__new__';
      listSel.appendChild(oNew);

      newName = el('input', 'bi-input bi-input--name');
      newName.type = 'text';
      newName.placeholder = T('newList');
      newName.hidden = true;
      listSel.addEventListener('change', function () {
        newName.hidden = listSel.value !== '__new__';
        if (!newName.hidden) newName.focus();
        updateLabel();
      });
      right.appendChild(listSel);
      right.appendChild(newName);
    }

    var go = el('button', 'bi-btn bi-btn--primary');
    go.type = 'button';
    right.appendChild(go);

    /**
     * ⚠️ Der Knopf ist NIE gesperrt, solange eine brauchbare Zeile da ist. Sind noch
     * Fehlerzeilen uebrig, sagt die Beschriftung ausdruecklich, dass sie uebersprungen
     * werden — der Kunde bestaetigt das damit, statt in einer Sackgasse zu stehen.
     */
    function updateLabel() {
      var cc = counts();
      var listName = '';
      if (listSel) {
        listName = listSel.value === '__new__'
          ? (newName.value.trim() || T('newList'))
          : (listSel.options[listSel.selectedIndex] || {}).text || '';
      }
      var base = st.target === 'list'
        ? fmt(T('toList') || '{n} Positionen in „{list}" legen', { n: cc.ok, list: listName })
        : st.target === 'callback'
          ? fmt(st.doneLabel || '{n} Artikel übernehmen', { n: cc.ok })
          : fmt(T('toCart') || '{n} Positionen in den Warenkorb legen', { n: cc.ok });
      go.textContent = cc.bad
        ? base + ' — ' + fmt(T('skipBad') || '{bad} überspringen', { bad: cc.bad })
        : base;
      go.disabled = cc.ok === 0;
    }
    if (newName) newName.addEventListener('input', updateLabel);
    updateLabel();

    go.addEventListener('click', function () {
      if (st.busy) return;
      var usable = st.rows.filter(rowUsable);
      if (!usable.length) return;
      if (st.target === 'list') {
        commitList(usable, listSel, newName, go);
      } else if (st.target === 'callback') {
        // Zurueckgeben statt buchen: Aufrufer bekommt die geprueften Zeilen ({sku, qty, …}).
        var fertig = st.onDone;
        close();
        fertig(usable);
      } else {
        commitCart(usable, go);
      }
    });

    elFoot.appendChild(right);
  }

  // ── Uebernahme: Warenkorb ──────────────────────────────────────────────────

  /**
   * Wohin der Warenkorb gerendert wird.
   *
   * ⚠️⚠️ NICHT einfach das Schubfach nehmen. settings.cart_type ist 'drawer', also liegt
   * <cart-drawer> auf JEDER Seite im DOM — auch auf /cart. Wer blind darauf rendert,
   * aktualisiert auf der Warenkorbseite die Blase, aber NICHT die sichtbare Tabelle.
   */
  function cartTarget() {
    var page = document.querySelector('cart-items');
    if (page && document.getElementById('main-cart-items') && document.getElementById('main-cart-footer')) {
      return { mode: 'page', el: page };
    }
    var drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    return drawer ? { mode: 'drawer', el: drawer } : { mode: 'none', el: null };
  }

  /**
   * Section-Angaben fuer die Section-Rendering-API.
   *
   * ⚠️⚠️ DIE BEIDEN ZIELE ADRESSIEREN UNTERSCHIEDLICH:
   *   Warenkorbseite (CartItems)  → ueber `.section` (die dynamische Section-Id aus
   *                                 dataset.id), und renderContents liest sie ebenso.
   *   Schubfach (CartDrawer)      → ueber `.id`; seine Eintraege haben GAR KEINE
   *                                 `.section`-Eigenschaft.
   * Wer hier `.section` fuer das Schubfach nimmt, fordert `sections=undefined` an. Die
   * Antwort enthaelt die Section dann nicht, und cart-drawer.js::getSectionInnerHTML
   * prueft NICHT auf null (:96) — der Kunde sieht
   * „Cannot read properties of null (reading 'innerHTML')".
   */
  function sectionsSpec() {
    var t = cartTarget();
    var entries = [];
    if (t.el && t.el.getSectionsToRender) {
      try { entries = t.el.getSectionsToRender() || []; } catch (e) { entries = []; }
    }
    var ids = entries
      .map(function (e) { return t.mode === 'page' ? e.section : e.id; })
      .filter(function (v) { return typeof v === 'string' && v !== ''; });

    // ⚠️⚠️ Im SEITENmodus zusaetzlich die Schubfach-Sections mitziehen.
    // CartItems.getSectionsToRender() kennt `cart-drawer` NICHT — das Schubfach liegt
    // aber auf jeder Seite im DOM und behaelt sonst seinen alten Inhalt, bis der Kunde
    // neu laedt. Genau das war der Befund: „Warenkorbseite passt, Schubfach nicht."
    var extra = t.mode === 'page' ? drawerEntries().filter(function (e) {
      return ids.indexOf(e.key) < 0;
    }) : [];
    extra.forEach(function (e) { ids.push(e.key); });

    return { mode: t.mode, el: t.el, entries: entries, extra: extra, ids: ids };
  }

  /**
   * Schubfach-Sections als {key, selector} — `key` ist zugleich der Name fuer die
   * Section-Rendering-API und der Schluessel in json.sections (das Schubfach adressiert
   * ueber `.id`, nicht ueber `.section`).
   */
  function drawerEntries() {
    var d = document.querySelector('cart-drawer');
    if (!d || !d.getSectionsToRender) return [];
    try {
      return (d.getSectionsToRender() || []).map(function (e) {
        return { key: e.id, selector: e.selector || null, hostId: e.id };
      }).filter(function (e) { return typeof e.key === 'string' && e.key !== ''; });
    } catch (e) { return []; }
  }

  function innerOf(html, selector) {
    var d = new DOMParser().parseFromString(String(html), 'text/html');
    var n = d.querySelector(selector || '.shopify-section');

    return n ? n.innerHTML : null;
  }

  /**
   * Warenkorb neu zeichnen.
   *
   * ⚠️⚠️ In beiden Zweigen MUSS cartUpdate veroeffentlicht werden: b2b-prices.js rechnet
   * die Warenkorbpreise erst dann um. Ohne das stehen dort die LISTENpreise, ohne dass
   * irgendwo ein Fehler erscheint.
   */
  function applyCart(json) {
    var spec = sectionsSpec();
    var secs = (json && json.sections) || {};
    var rendered = false;

    if (spec.mode === 'drawer' && spec.el && spec.el.renderContents) {
      // ⚠️ Vollstaendigkeit VORHER pruefen. renderContents des Themes faengt eine
      // fehlende Section nicht ab und wirft mitten im Durchlauf — dann ist der Warenkorb
      // halb gerendert und der Kunde sieht eine rohe Fehlermeldung.
      var complete = spec.ids.length > 0 && spec.ids.every(function (id) {
        return typeof secs[id] === 'string';
      });
      if (complete) {
        if (spec.el.classList.contains('is-empty')) spec.el.classList.remove('is-empty');
        try { spec.el.renderContents(json); rendered = true; } catch (e) { rendered = false; }
      }
    } else if (spec.mode === 'page') {
      // ⚠️ <cart-items> hat KEIN renderContents(). Die Sections werden von Hand
      // ersetzt — genau wie in cart.js::updateQuantity (:137-145) — und `is-empty`
      // an drei Stellen nachgezogen.
      var empty = json && json.item_count === 0;
      spec.el.classList.toggle('is-empty', !!empty);
      var foot = document.getElementById('main-cart-footer');
      if (foot) foot.classList.toggle('is-empty', !!empty);
      var dr = document.querySelector('cart-drawer');
      if (dr) dr.classList.toggle('is-empty', !!empty);

      spec.entries.forEach(function (sec) {
        var host = document.getElementById(sec.id);
        if (!host) return;
        var html = secs[sec.section];
        if (typeof html !== 'string') return;
        var inner = innerOf(html, sec.selector);
        if (inner === null) return;                    // fehlt der Ausschnitt: nichts anfassen
        var target = host.querySelector(sec.selector) || host;
        target.innerHTML = inner;
        rendered = true;
      });

      // Schubfach nachziehen — ohne es zu OEFFNEN. renderContents() des Themes wuerde
      // es aufklappen (:87-90); auf der Warenkorbseite waere das aufdringlich.
      (spec.extra || []).forEach(function (e) {
        var host = e.selector ? document.querySelector(e.selector) : document.getElementById(e.hostId);
        if (!host) return;
        var html = secs[e.key];
        if (typeof html !== 'string') return;
        var inner = innerOf(html, e.selector);
        if (inner !== null) host.innerHTML = inner;
      });
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bulk-import', cartData: json });
    }
    if (typeof window.B2BRefreshCart === 'function') setTimeout(window.B2BRefreshCart, 0);

    return rendered;
  }

  function fetchCartSections() {
    var ids = sectionsSpec().ids;
    if (!ids.length) return Promise.reject(new Error('keine Sections'));
    var base = (window.routes && window.routes.cart_url) ||
               (window.localizeUrl ? window.localizeUrl('/cart') : '/cart');
    return fetch(base + '?sections=' + encodeURIComponent(ids.join(',')), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('sections')); });
  }

  /**
   * Echten Serverstand holen und anwenden. Rueckfall, wenn /cart/add.js keine oder
   * unvollstaendige Sections geliefert hat.
   */
  function refreshFromServer() {
    return fetchCartSections().then(function (secs) {
      // /cart?sections=… liefert NUR die Sections, keinen item_count. Fuer die
      // is-empty-Umschaltung wird der Warenkorbstand deshalb separat geholt.
      var url = window.localizeUrl ? window.localizeUrl('/cart.js') : '/cart.js';

      return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.json() : {}; })
        .catch(function () { return {}; })
        .then(function (cart) {
          cart.sections = secs;

          return applyCart(cart);
        });
    });
  }

  function addUrl() {
    return window.localizeUrl ? window.localizeUrl('/cart/add.js') : '/cart/add.js';
  }

  function postItems(items, withSections) {
    var body = { items: items };
    if (withSections) {
      // ⚠️ Ueber sectionsSpec(), NICHT ueber eine eigene Liste: Warenkorbseite und
      // Schubfach adressieren ihre Sections unterschiedlich (siehe dort).
      var ids = sectionsSpec().ids;
      if (ids.length) {
        body.sections = ids;
        body.sections_url = window.location.pathname;
      }
    }
    var cfg = (typeof fetchConfig === 'function')
      ? fetchConfig('javascript')
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
    cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
    cfg.body = JSON.stringify(body);
    return fetch(addUrl(), cfg).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
    });
  }

  /**
   * Uebernahme in Bloecken zu 50, NACHEINANDER.
   *
   * ⚠️ Shopifys Warenkorb ist bei gleichzeitigen Schreibvorgaengen auf demselben Token
   * nicht sicher — parallele Adds verlieren Zeilen.
   *
   * ⚠️⚠️ Ein 422 betrifft den GANZEN Block: eine einzige gesperrte Position kann 49
   * einwandfreie mitreissen. Deshalb wird ein gescheiterter Block positionsweise
   * wiederholt, der Stoerenfried benannt und der Rest uebernommen.
   */
  /** Momentaufnahme des Warenkorbs: Variantennummer → Menge. null = nicht ermittelbar. */
  function snapshotCart() {
    var url = window.localizeUrl ? window.localizeUrl('/cart.js') : '/cart.js';

    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items) return null;
        var m = {};
        c.items.forEach(function (i) { m[i.variant_id] = (m[i.variant_id] || 0) + i.quantity; });

        return m;
      })
      .catch(function () { return null; });
  }

  function commitCart(rows, btn) {
    var items = rows.map(function (r) { return { id: r.id, quantity: cartQty(r), _row: r }; });
    var chunks = [];
    for (var i = 0; i < items.length; i += CHUNK) chunks.push(items.slice(i, i + CHUNK));

    // ⚠️ Grund je Zeile mitschreiben. Shopify liefert bei Bestandsmangel eine
    // LOKALISIERTE Beschreibung („Es sind nur noch N … verfuegbar") — die ist praeziser
    // als alles, was wir selbst formulieren koennten, und wird deshalb bevorzugt gezeigt.
    var reasons = {};
    var done = 0;

    busy(true);
    btn.disabled = true;
    var prog = el('span', 'bi-progress');
    btn.parentNode.insertBefore(prog, btn);
    function tick() {
      prog.textContent = fmt(T('progress') || '{done} von {total} übernommen …',
                             { done: done, total: items.length });
    }
    tick();

    function note(res) {
      var j = res && res.json;
      if (!j) return null;

      return (typeof j.description === 'string' && j.description) ||
             (typeof j.message === 'string' && j.message) || null;
    }

    function runChunk(n) {
      if (n >= chunks.length) return Promise.resolve();
      var last = n === chunks.length - 1;
      var payload = chunks[n].map(function (x) { return { id: x.id, quantity: x.quantity }; });

      return postItems(payload, last).then(function (res) {
        if (res.ok && !res.json.status) {
          done += chunks[n].length;
          tick();
          if (last && !applyCart(res.json)) {
            return refreshFromServer().catch(function () {}).then(function () { return runChunk(n + 1); });
          }

          return runChunk(n + 1);
        }
        // ⚠️⚠️ Ein 422 betrifft den GANZEN Block: eine gesperrte Position reisst sonst
        // die uebrigen mit. Deshalb positionsweise wiederholen.
        return oneByOne(chunks[n]).then(function () { return runChunk(n + 1); });
      });
    }

    function oneByOne(chunk) {
      return chunk.reduce(function (p, x) {
        return p.then(function () {
          return postItems([{ id: x.id, quantity: x.quantity }], false).then(function (res) {
            if (res.ok && !res.json.status) { done++; }
            else { reasons[x.id] = note(res); }
            tick();
          });
        });
      }, Promise.resolve());
    }

    var before = null;
    snapshotCart()
      .then(function (snap) { before = snap; return runChunk(0); })
      .then(function () { return refreshFromServer().catch(function () {}); })
      .then(function () { return snapshotCart(); })
      .then(function (after) {
        busy(false);
        btn.disabled = false;
        prog.remove();
        finishCart(rows, before, after, reasons, done);
      })
      .catch(function (e) {
        busy(false);
        btn.disabled = false;
        prog.remove();
        showReviewError(e.message || T('failed'));
      });
  }

  /**
   * Ergebnis einordnen: was ist vollstaendig angekommen, was nur teilweise, was gar nicht.
   *
   * ⚠️⚠️ Shopify DECKELT bei knappem Bestand, statt abzulehnen: es antwortet mit 422 und
   * „Aufgrund der Verfuegbarkeit wurde nur 1 Artikel zu deinem Warenkorb hinzugefuegt." —
   * und legt die eine Einheit TROTZDEM hinein. Wer nur auf den Statuscode schaut, meldet
   * „nicht uebernommen", obwohl etwas drin ist; wer ihn ignoriert, meldet vollen Erfolg.
   * Massgeblich ist deshalb der Vergleich des Warenkorbs VORHER und NACHHER.
   *
   * ⚠️ Ist der Vergleich nicht moeglich (Warenkorb nicht abrufbar), wird NICHT pauschal
   * Erfolg behauptet: dann zaehlen die von Shopify gemeldeten Gruende als Beleg, nur eben
   * ohne genaue Stueckzahl.
   *
   * @return {{full:Array, partial:Array, none:Array, exact:boolean}}
   */
  function classifyResult(rows, before, after, reasons) {
    var full = [], partial = [], none = [];
    var exact = !!(before && after);

    rows.forEach(function (r) {
      var want = cartQty(r);

      if (exact) {
        var got = (after[r.id] || 0) - (before[r.id] || 0);
        if (got >= want)   full.push(r);
        else if (got > 0)  partial.push({ row: r, got: got, want: want });
        else               none.push({ row: r, want: want });

        return;
      }

      if (reasons[r.id]) partial.push({ row: r, got: null, want: want });
      else               full.push(r);
    });

    return { full: full, partial: partial, none: none, exact: exact };
  }

  function finishCart(rows, before, after, reasons, done) {
    var res = classifyResult(rows, before, after, reasons);

    if (!res.partial.length && !res.none.length) {
      close();
      // ⚠️ `done` statt rows.length: gezaehlt wird, was Shopify bestaetigt hat.
      toast(fmt(T('importedCart') || '{n} Positionen in den Warenkorb gelegt',
                { n: res.exact ? rows.length : (done != null ? done : rows.length) }));

      return;
    }

    renderResult(res, reasons);
    toast(fmt(T('importedSome') || '{ok} von {n} Positionen übernommen',
              { ok: res.full.length + res.partial.length, n: rows.length }));
  }

  function nameOf(r) {
    return (displayTitle(r) || r.sku) + (r.vt ? ' · ' + r.vt : '');
  }

  function renderResult(res, reasons) {
    elStep2.textContent = '';
    elFoot.textContent = '';

    var head = el('div', 'bi-result__head');
    head.appendChild(el('h3', 'bi-result__title', T('resultHeading')));
    head.appendChild(el('p', 'bi-result__sub',
      fmt(T('resultSub'), { ok: res.full.length + res.partial.length })));
    elStep2.appendChild(head);

    var list = el('ul', 'bi-result__list');

    res.partial.forEach(function (p) {
      var li = el('li', 'bi-result__item bi-result__item--partial');
      li.appendChild(el('span', 'bi-result__name', nameOf(p.row)));
      li.appendChild(el('span', 'bi-result__what',
        p.got === null ? T('partialUnknown') : fmt(T('partialQty'), { got: p.got, want: p.want })));
      // ⚠️ Shopifys eigene Begruendung bevorzugen — sie nennt die genaue Restmenge und ist
      // bereits in der Sprache des Kunden.
      li.appendChild(el('span', 'bi-result__why', reasons[p.row.id] || T('stockReason')));
      list.appendChild(li);
    });

    res.none.forEach(function (p) {
      var li = el('li', 'bi-result__item bi-result__item--none');
      li.appendChild(el('span', 'bi-result__name', nameOf(p.row)));
      li.appendChild(el('span', 'bi-result__what', T('notAdded')));
      li.appendChild(el('span', 'bi-result__why', reasons[p.row.id] || T('stockReasonNone')));
      list.appendChild(li);
    });

    elStep2.appendChild(list);
    elStep2.appendChild(el('p', 'bi-hint', T('resultHint')));

    var done = el('button', 'bi-btn bi-btn--primary', T('toCartDone'));
    done.type = 'button';
    done.addEventListener('click', function () {
      close();
      var url = window.localizeUrl ? window.localizeUrl('/cart') : '/cart';
      if (location.pathname.replace(/\/$/, '') !== url.replace(/\/$/, '')) location.href = url;
    });
    var later = el('button', 'bi-btn bi-btn--ghost', T('close'));
    later.type = 'button';
    later.addEventListener('click', close);

    var right = el('div', 'bi__footright');
    right.appendChild(later);
    right.appendChild(done);
    elFoot.appendChild(el('div', 'bi__footleft'));
    elFoot.appendChild(right);

    announce(T('resultHeading'));
  }

  // ── Uebernahme: Favoritenliste ─────────────────────────────────────────────

  function commitList(rows, listSel, newName, btn) {
    var payload = {
      items: rows.map(function (r) {
        return {
          sku: r.sku,
          // ⚠️ Favoriten duerfen die Nachkommastelle behalten (qty DECIMAL(10,3)) —
          // anders als der Warenkorb, der nur ganze Einheiten kennt.
          qty: packQty(r),
          handle: r.handle,
          variantId: r.id,
          title: r.title,
          variantTitle: r.vt,
          imageUrl: r.img,
          category: r.cat
        };
      })
    };
    if (listSel && listSel.value === '__new__') {
      var nm = (newName.value || '').trim();
      if (!nm) { newName.focus(); return; }
      payload.newListName = nm;
    } else if (listSel) {
      payload.listId = parseInt(listSel.value, 10) || 0;
    } else if (st.listId) {
      payload.listId = st.listId;
    }

    busy(true);
    btn.disabled = true;
    apiFavImport(payload).then(function (res) {
      busy(false);
      btn.disabled = false;
      close();
      toast(fmt(T('importedList') || '{n} Positionen übernommen ({new} neu, {inc} ergänzt)',
                { n: res.created + res.increased, 'new': res.created, inc: res.increased }));
      // Liste neu laden, damit die Seite den neuen Stand zeigt.
      var F = window.Favorites;
      if (F && F.load) F.load().then(function () {
        document.dispatchEvent(new CustomEvent('favorites:changed'));
      });
    }).catch(function (e) {
      busy(false);
      btn.disabled = false;
      showReviewError(e.message === 'anonymous'
        ? (T('loginNeeded') || 'Bitte zuerst anmelden.')
        : (e.message || T('failed')));
    });
  }

  function showReviewError(msg) {
    var box = elStep2.querySelector('.bi-error') || el('p', 'bi-error');
    box.textContent = msg;
    box.setAttribute('role', 'alert');
    if (!box.parentNode) elStep2.insertBefore(box, elStep2.firstChild);
  }

  function toast(msg) {
    var F = window.Favorites;
    if (F && F.toast) { F.toast(msg); return; }
    // Eigener Rueckfall: favorites.js laedt erst am Seitenende und ist auf der
    // Warenkorbseite nicht garantiert schon da.
    var t = el('div', 'bi-toast', msg);
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('is-out'); }, 4000);
    setTimeout(function () { t.remove(); }, 4600);
  }

  // ── Einstieg ───────────────────────────────────────────────────────────────

  function open(opts) {
    opts = opts || {};
    ensureDialog();
    st = freshState(opts);
    st.trigger = document.activeElement;
    dlg.classList.toggle('bi--list', st.target === 'list');
    renderStep1();

    if (typeof dlg.showModal === 'function') {
      if (!dlg.open) dlg.showModal();
    } else {
      // Rueckfall fuer Browser ohne <dialog> — sichtbar machen reicht, der Rest
      // funktioniert unveraendert.
      dlg.setAttribute('open', 'open');
      dlg.classList.add('bi--nodialog');
    }
  }

  window.BulkImport = { open: open, close: close };
  window.__T3 = { classifyResult: classifyResult, cartQty: cartQty };

  // Knoepfe im Liquid-Markup verdrahten (Warenkorbseite, Schubfach).
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bulk-import]');
    if (!b) return;
    e.preventDefault();
    open({ target: b.getAttribute('data-bulk-import') === 'list' ? 'list' : 'cart' });
  });

  // Direktlink aus Mails/Kampagnen: ?schnellerfassung=1 auf /cart oeffnet das
  // Fenster automatisch, ohne dass erst der Knopf geklickt werden muss.
  try {
    if (new URLSearchParams(window.location.search).get('schnellerfassung') === '1') {
      open({ target: 'cart' });
    }
  } catch (e) {}
})();
